import { render, staticRenderFns } from "./ServiceAssessmentAssessmentPlanning.vue?vue&type=template&id=4fd96179&scoped=true"
import script from "./ServiceAssessmentAssessmentPlanning.vue?vue&type=script&lang=js"
export * from "./ServiceAssessmentAssessmentPlanning.vue?vue&type=script&lang=js"
import style0 from "./ServiceAssessmentAssessmentPlanning.vue?vue&type=style&index=0&id=4fd96179&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd96179",
  null
  
)

export default component.exports